import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

/**
 * Initializes Google Analytics 4. No-ops if no measurement ID is configured
 * (e.g. local development without REACT_APP_GA_MEASUREMENT_ID set), so the app
 * runs the same with or without analytics wired up.
 */
export const initGA = () => {
  if (initialized || !MEASUREMENT_ID) {
    return;
  }

  ReactGA.initialize(MEASUREMENT_ID);
  initialized = true;
};

/** Sends a pageview for the given path (e.g. "/about-us"). */
export const trackPageview = (path) => {
  if (!initialized) {
    return;
  }

  ReactGA.send({ hitType: 'pageview', page: path });
};

/**
 * Sends a custom event.
 * @example trackEvent({ category: 'Class', action: 'play', label: classId })
 */
export const trackEvent = ({ category, action, label, value }) => {
  if (!initialized) {
    return;
  }

  ReactGA.event({ category, action, label, value });
};

export const isAnalyticsEnabled = () => Boolean(MEASUREMENT_ID);
